import { useState } from 'react';
import '../App.css';
import { Container, Row, Col } from 'react-bootstrap';
import { rules } from '../data/rules';
import RulesModal from '../components/RulesModa';
import Rule from '../schemas/Rule';

function RulesPage() {
  const [selectedRule, setSelectedRule] = useState<Rule | null>(null);
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = (rule: Rule) => {
    setSelectedRule(rule);
    setShowModal(true);
  };

  return (
    <div id="rules" className="mt-3 d-flex flex-column" dir="rtl">
      <h3 className="text-center mb-3">תקנון הליגה</h3>
      <p className="mt-3 text-center">
        כאן תוכלו למצוא את חוקי הליגה כלשונם, מקובצים ומסווגים בהתאם לקטגוריות שונות, ובליווי הסברים, שאלות ותשובות ודוגמאות.
      </p>

      <Container className="m-4">
        <Row className="g-3 justify-content-center">
          {rules.map((rule) => (
            <Col md={3} sm={6} key={rule.id}>
              <div
                onClick={() => handleOpenModal(rule)}
                className="rule-card text-center p-3 shadow-sm rounded border clickable"
                style={{ cursor: 'pointer', transition: '0.3s' }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = '#f8f9fa')
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = 'white')
                }
              >
                <h5 className="text-primary mb-0">{rule.title}</h5>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      <RulesModal
        rule={selectedRule}
        show={showModal}
        setShow={setShowModal}
        fullscreen={true}
      />
    </div>
  );
}

export default RulesPage;